import * as angular from 'angular';

import { TagDefinition } from '../../models';
import { IDispatcherService, IDispatcher } from '../';
import { ITagDefinitionActionsService } from './tags.actionCreator';

export interface ITagStoreService {
    getAll():  angular.IPromise<TagDefinition[]>;
    getAll(force: boolean): angular.IPromise<TagDefinition[]>;
    getOne(guid: string): angular.IPromise<TagDefinition>;
    update(tags: TagDefinition[]): angular.IPromise<TagDefinition[]>;
    create(tag: TagDefinition): angular.IPromise<TagDefinition>;
    delete(guids: string[]): angular.IPromise<TagDefinition[]>;
    forceInMemoryUpdate(updated: TagDefinition[]): angular.IPromise<TagDefinition[]>;
}

export interface ITagActionDispatcherService extends IDispatcherService<ITagStoreService> { }

export class TagActionDispatcherService implements ITagActionDispatcherService {
    static serviceId = 'tagActionDispatcherService';

    static $inject = ['tagDefinitionActionsService'];

    constructor(private _actionService: ITagDefinitionActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<ITagStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getOne: (guid: string) => dispatch(actionService.getOne(guid)),
                getAll: (force?: boolean) => dispatch(actionService.getAll(force)),
                update: (tags: TagDefinition[]) => dispatch(actionService.update(tags)),
                create: (tag: TagDefinition) => dispatch(actionService.create(tag)),
                delete: (guids: string[]) => dispatch(actionService.delete(guids)),
                forceInMemoryUpdate: (updated: TagDefinition[]) => dispatch(actionService.forceInMemoryUpdate(updated))
            }
        };
    }
}